
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Layout from '@/components/layout/Layout';
import ExperiencedHero from '@/components/experienced/ExperiencedHero';
import ExperiencedBenefits from '@/components/experienced/ExperiencedBenefits';
import ExperiencedJourney from '@/components/experienced/ExperiencedJourney';
import ExperiencedTestimonials from '@/components/experienced/ExperiencedTestimonials';
import ExperiencedFAQ from '@/components/experienced/ExperiencedFAQ';
import { preloadCriticalImages } from '@/utils/optimizeImages';
import AboutCTA from '@/components/about/AboutCTA';

const ExperiencedPianoLessons = () => {
  // Preload critical images for performance
  useEffect(() => {
    preloadCriticalImages([
      '/lovable-uploads/c3099eea-1cdc-462a-9e3c-85f757436352.png'
    ]);
  }, []);

  return (
    <Layout>
      <div id="top"></div>
      <Helmet>
        <title>Klaverundervisning for øvede pianister | Forfin din teknik og udtryk</title>
        <meta name="description" content="Professionel klaverundervisning for øvede pianister. Udvikl avanceret teknik, musikalsk udtryk og repertoire med konservatorieuddannet pianist. Book din time i dag!" />
        <link rel="canonical" href="https://pianoundervisning.dk/klaverundervisning-ovede" />
        <meta property="og:title" content="Klaverundervisning for øvede pianister | Forfin din teknik og udtryk" />
        <meta property="og:description" content="Professionel klaverundervisning for øvede pianister. Udvikl avanceret teknik, musikalsk udtryk og repertoire med konservatorieuddannet pianist." />
        <meta property="og:url" content="https://pianoundervisning.dk/klaverundervisning-ovede" />
        <meta property="og:type" content="website" />
        <meta name="keywords" content="klaverundervisning øvede, avanceret klaverundervisning, professionel klaverundervisning, klaver for viderekomne, musikfortolkning" />
      </Helmet>

      <ExperiencedHero />
      <ExperiencedBenefits />
      <ExperiencedJourney />
      <ExperiencedTestimonials />
      <ExperiencedFAQ />
      <AboutCTA 
        title="Tag dit klaverspil til næste niveau"
        description="Lad os arbejde sammen om at forfine din teknik, udvide dit repertoire og udvikle din personlige musikalske stemme."
        primaryButtonText="Book en time"
        secondaryButtonText="Se alle undervisningstilbud"
      />
    </Layout>
  );
};

export default ExperiencedPianoLessons;
